import { PriceHelper } from "../../../Lib/Helper/PriceHelper";
import { ForeignCurrencyPriceHelper } from "../../../Lib/Helper/ForeignCurrencyPriceHelper";
import { AxLoad } from "../../../Lib/AxSystem/AxLoad";
import { LocalizationModule } from "../../../Modules/Global/LocalizationModule";
import { AxCounter } from "../../../Limestone/AxCounter/AxCounter";
import { RentalProductDetails } from "../../../Modules/Rental/ProductDetails/RentalProductDetails";

export class RentDetailsSingleItemSelectionSection {
    projNr: number;
    personTypeId: number;
    rentalItemId: number;

    private itemsSelectedCount: number;

    private basePrice: number = 0;
    private basePriceHolder: HTMLElement;
    private totalPriceHolder: HTMLElement;

    private priceHelper: PriceHelper;
    private foreignCurrencyHelper: ForeignCurrencyPriceHelper;

    constructor(wrapperElement: HTMLElement, pricesPerPersonType: any, foreignCurrencyHelper?: ForeignCurrencyPriceHelper) {
        this.itemsSelectedCount = 0;
        this.basePrice =

            this.projNr = parseInt(wrapperElement.getAttribute("data-item-projNr"));
        this.personTypeId = parseInt(wrapperElement.getAttribute("data-item-personTypeId"));
        this.rentalItemId = parseInt(wrapperElement.getAttribute("data-item-id"));

        this.addBasePrice(pricesPerPersonType);

        this.initItemCounters();

        this.priceHelper = new PriceHelper(null, true);
        this.foreignCurrencyHelper = foreignCurrencyHelper;

        this.basePriceHolder = document.querySelector(`[data-item-basePrice-idendifier="${this.personTypeId}"]`);
        this.totalPriceHolder = document.querySelector(`[data-item-priceSum-idendifier="${this.personTypeId}"]`);
    }

    getPostData(): any {
        const postData = {
            ProjNr: this.projNr,
            RentalItemId: this.rentalItemId,
            RentalPersonTypeId: this.personTypeId,
            Count: this.getItemsSelectedCount()
        }

        return postData;
    }

    updateBasePriceLabel() {
        const localizationModule = AxLoad.GetModule<LocalizationModule>('LocalizationModule');
        const basePriceLabelText = this.priceHelper.GetPriceStringWithCurrencySymbol(this.basePrice / localizationModule.getPriceToDecimalDivisor());
        this.basePriceHolder.innerHTML = basePriceLabelText + this.getForeignCurrencyHtml(this.basePrice);
    }

    updateTotalPriceLabel() {
        const localizationModule = AxLoad.GetModule<LocalizationModule>('LocalizationModule');
        const sumPriceLabelPrice = this.priceHelper.GetPriceStringWithCurrencySymbol(this.getSectionTotalPrice() / localizationModule.getPriceToDecimalDivisor());
        this.totalPriceHolder.innerHTML = sumPriceLabelPrice + this.getForeignCurrencyHtml(this.getSectionTotalPrice());
    }

    getSectionTotalPrice(): number {
        const totalPrice = this.basePrice * this.itemsSelectedCount;
        return totalPrice;
    }

    updatePriceLabels() {
        this.updateBasePriceLabel();
        this.updateTotalPriceLabel();
    }

    getItemsSelectedCount() {
        return this.itemsSelectedCount;
    }

    private getForeignCurrencyHtml(priceInCent: number): string {
        return this.foreignCurrencyHelper?.getForeignCurrencyHtml(priceInCent) ?? '';
    }

    private addBasePrice(pricesPerPersonType: any) {
        const personTypePrice = pricesPerPersonType
            .find(x => x.personTypeNr === this.personTypeId);

        this.basePrice = personTypePrice.price;
    }

    private initItemCounters() {
        const axCounter = new AxCounter();

        axCounter.Init({
            Value: 0,
            Selector: this.getCounterSelector(),
            Max: 10,
            Min: 0,
        });

        axCounter.Subscribe((x) => {
            this.itemsSelectedCount = x;
            this.updatePriceLabels();
            AxLoad.GetModule<RentalProductDetails>('RentalProductDetails').refreshProceedBtn();
        });
    }

    getCounterSelector(): string {
        return `.prod__counter_singleItem_${this.personTypeId}`;
    }
}